import React from "react";
import MetricCard from "./MetricCard";

const DATASET_INFO = [
  { label: "Dataset", getValue: (m, v) => m?.datasetName || "-", icon: "fa-database" },
  { label: "Visibility", getValue: (m) => m?.visibility || "Private", icon: "fa-eye" },
  { label: "Created By", getValue: (m) => m?.createdBy || "-", icon: "fa-user" },
  { label: "Training Date", getValue: (m, v) => v?.trainingCompletedAt || "-", icon: "fa-calendar" },
];

const OverviewStrip = ({ model, version, modelType, statCards, formatMetric }) => {
  const datasetInfo = DATASET_INFO.map(({ label, getValue, icon }) => ({
    label,
    value: getValue(model, version),
    icon,
  }));

  return (
    <section className="overview-strip">
      <div className="overview-strip__grid">
        <div className="overview-strip__info">
          <h3 className="overview-strip__section-title">Dataset &amp; Model Info</h3>
          <div className="overview-strip__info-grid">
            {datasetInfo.map(({ label, value, icon }) => (
              <div key={label} className="overview-strip__info-item">
                <span className="overview-strip__info-label">{label}</span>
                <span className="overview-strip__info-value">
                  <i className={`fa ${icon} mr-2 text-primary`} />{value || "-"}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="overview-strip__metrics">
          <h3 className="overview-strip__section-title">Model Performance</h3>
          <div className="overview-strip__metrics-grid">
            {statCards.map((card) => {
              const val = formatMetric(card.key, card.fallback);
              const numVal = parseFloat(val);
              const showProgress = !Number.isNaN(numVal) && numVal <= 1;
              return (
                <MetricCard
                  key={card.label}
                  label={card.label}
                  value={val}
                  icon={card.icon}
                  color={card.color}
                  showProgress={showProgress}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverviewStrip;
